import { Unstable_Grid2 as Grid } from '@mui/material';

import { Select, TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { membershipCreatedOperatorOptions } from './constants';

export type MembershipCreatedTargetingAttributeProps = {
  fieldName: string;
};

export const MembershipCreatedTargetingAttribute = ({
  fieldName,
}: MembershipCreatedTargetingAttributeProps) => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${fieldName}.operator`}
          label='Comparison'
          data={membershipCreatedOperatorOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <TextField
          name={`${fieldName}.amount`}
          label='Days ago'
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>
    </Grid>
  );
};
